import { ColorConstants } from '@shared/constants';

export const PLEASE_WAIT = 'Please wait a few more seconds while we set everything up';

export const SIGN_OUT = 'Sign Out';

export const colors = {
    logo: ColorConstants.white,
    firstLetter: ColorConstants.white,
    secondLetter: ColorConstants.white,
    thirdLetter: ColorConstants.white,
    fourthFifthLetters: ColorConstants.white,
    sixthLetter: ColorConstants.white,
};

export const TEST_ID = {
    SPLASH_SCREEN_IMAGE: 'SPLASH_SCREEN_IMAGE',
    SPLASH_SCREEN_ERROR_MESSAGE: 'SPLASH_SCREEN_ERROR_MESSAGE',
    SPLASH_SCREEN_SIGN_OUT_BUTTON: 'SPLASH_SCREEN_SIGN_OUT_BUTTON',
};
